module.exports = __webpack_public_path__ + "img/vehicle-search.f9cfb9c1.png";